import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import {
    createAPIDefaultEndpoint,
    Endpoint,
} from "../../../Services/DefaultSetting/DefaultSettingService";
import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import { InputText } from "primereact/inputtext";

const DefaultSettings = () => {
    const [getAllDefault, SetGetAllDefault] = useState([]);
    const [nonInvSupp, setNonInvSupp] = useState("");
    const [nonInvSuppOptions, setNonInvSuppOptions] = useState(null);
    const [orderCancellationReason, setOrderCancellationReason] = useState("");
    const [orderCancellationReasonOptions, setOrderCancellationReasonOptions] =
        useState(null);
    const [supplier, setSupplier] = useState("");
    const [supplierOptions, setSupplierOptions] = useState(null);
    const [taxArea, setTaxArea] = useState("");
    const [taxAreaOptions, setTaxAreaOptions] = useState(null);
    const [warehouse, setWarehouse] = useState("");
    const [warehouseOptions, setWarehouseOptions] = useState(null);
    const [cncleInvSetting, setCncleInvSetting] = useState("");
    const [cncleInvSettingOptions, setcncleInvSettingOptions] = useState(null);
    const [branch, setBranch] = useState("");
    const [branchOption, setBranchOption] = useState(null);
    const [currency, setCurrency] = useState("");
    const [currencyOption, setCurrencyOption] = useState(null);
    const [approvedBy, setApprovedBy] = useState("");
    const [approvedByOption, setApprovedByOption] = useState(null);
    const [division, setDivision] = useState("");
    const [divisionOption, setDivisionOption] = useState(null);
    const [tolerance, setTolerance] = useState("");
    const [inspectedBy, setInspectedBy] = useState("");
    const [inspectedByOption, setInspectedByOption] = useState(null);
    const [location, setLocation] = useState("");
    const [locationOption, setLocationOption] = useState(null);
    const [modeofOrder, setModeofOrder] = useState("");
    const [modeofOrderOption, setModeofOrderOption] = useState(null);
    const [paymentTerm, setPaymentTerm] = useState("");
    const [paymentTermOption, setPaymentTermOption] = useState(null);
    const [raisedBy, setRaisedBy] = useState("");
    const [raisedByOption, setRaisedByOption] = useState(null);
    const [receiptMode, setReceiptMode] = useState("");
    const [receiptModeOption, setReceiptModeOption] = useState(null);
    const [receivedBy, setReceivedBy] = useState("");
    const [receivedByOption, setReceivedByOption] = useState(null);
    const [salesOrder, setSalesOrder] = useState("");
    const [stockType, setStockType] = useState("");
    const [stockTypeOption, setStockTypeOption] = useState(null);
    const [taxForm, setTaxForm] = useState("");
    const [taxFormOption, setTaxFormOption] = useState(null);
    const [taxRegiCode, setTaxRegiCode] = useState("");
    const [taxRegiCodeOption, setTaxRegiCodeOption] = useState(null);

    const [drpdwnVisblNonInv, setDrpdwnVisblNonInv] = useState(true);
    const [drpdwnVisblOrdrCncl, setDrpdwnVisblOrdrCncl] = useState(true);
    const [drpdwnVisblSupp, setDrpdwnVisblSupp] = useState(true);
    const [drpdwnVisblTxAr, setDrpdwnVisblTxAr] = useState(true);
    const [drpdwnVisblWhrHus, setDrpdwnVisblWhrHus] = useState(true);
    const [drpdwnVisblcnclInvSettng, setDrpdwnVisblcnclInvSettng] = useState(true);
    const [drpdwnVisblApprovedBy, setDrpdwnVisblApprovedBy] = useState(true);
    const [drpdwnVisblBranch, setDrpdwnVisblBranch] = useState(true);
    const [drpdwnVisblCurrency, setDrpdwnVisblCurrency] = useState(true);
    const [drpdwnVisblDivision, setDrpdwnVisblDivision] = useState(true);
    const [drpdwnVisblInspectedBy, setDrpdwnVisblInspectedBy] = useState(true);
    const [drpdwnVisblLocation, setDrpdwnVisblLocation] = useState(true);
    const [drpdwnVisblModeofOrder, setDrpdwnVisblModeofOrder] = useState(true);
    const [drpdwnVisblPaymentTerm, setDrpdwnVisblPaymentTerm] = useState(true);
    const [drpdwnVisblRaisedBy, setDrpdwnVisblRaisedBy] = useState(true);
    const [drpdwnVisblReceiptMode, setDrpdwnVisblReceiptMode] = useState(true);
    const [drpdwnVisblReceivedBy, setDrpdwnVisblReceivedBy] = useState(true);
    const [drpdwnVisblStockType, setDrpdwnVisblStockType] = useState(true);
    const [drpdwnVisblTaxForm, setDrpdwnVisblTaskForm] = useState(true);
    const [drpdwnVisblTaxRegiCode, setDrpdwnVisblTaxRegiCode] = useState(true);


    const [loading, setLoading] = useState(false);
    //   const [btnDisble, setBtnDisble] = useState(true);

    const auth = storage.getLocal("user");

    //   useEffect(() => {
    //     setBtnDisble(false);
    //   }, [supplier|nonInvSupp|warehouse|taxArea|orderCancellationReason]);

    useEffect(() => {
        fetchAllData();
    }, []);

    const fetchAllData = () => {
        setLoading(true);
        createAPIDefaultEndpoint()
            .get(`${Endpoint.DefaultSettings}?CompId=${auth.CompId}`)
            .then((val) => {
                const toleranceData = val.data.find(item => item.FIELD_NAME === "GRN Tolerance") || {};
                setTolerance({
                    ...toleranceData,
                    MASK_ID: toleranceData.MASK_ID || toleranceData.MASK_DEFAULT_VALUE || "",
                });
                SetGetAllDefault(val.data);
                val.data.map((item) => {
                    fetchApiAllData(
                        item.MASK_DEF_ID,
                        item.MASK_VALUE_COL,
                        item.MASK_DISPLAY_COL,
                        item.MASK_TABLE_NAME,
                        item.HOT_SEARCH,
                        item.MASK_DEFAULT_VALUE
                    );
                });
                SetGetAllDefault(val.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };
  
    const handelSaveData = () => {
        // console.log(nonInvSupp);
        // console.log(orderCancellationReason);
        // console.log(supplier);
        // console.log(taxArea);
        // console.log(warehouse);
        // console.log(getAllDefault);
        // console.log(cncleInvSetting);
        let payLoadData = [];
        getAllDefault.forEach((item) => {


            if (item.FIELD_NAME === "Supplier") {
                if (item.MASK_DEFAULT_VALUE != supplier.MASK_ID) {
                    let suppData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: supplier.MASK_ID,
                    };
                    payLoadData.push(suppData);
                }
            } else if (item.FIELD_NAME === "Warehouse") {
                if (item.MASK_DEFAULT_VALUE != warehouse.MASK_ID) {
                    let wareData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: warehouse.MASK_ID,
                    };
                    payLoadData.push(wareData);
                }
            } else if (item.FIELD_NAME === "Non Inventory Supplier") {
                if (item.MASK_DEFAULT_VALUE != nonInvSupp.MASK_ID) {
                    let noninvData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: nonInvSupp.MASK_ID,
                    };
                    payLoadData.push(noninvData);
                }
            } else if (item.FIELD_NAME === "Order Cancellation Reason") {
                if (item.MASK_DEFAULT_VALUE != orderCancellationReason.MASK_ID) {
                    let orderCanclData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: orderCancellationReason.MASK_ID,
                    };
                    payLoadData.push(orderCanclData);
                }
            } else if (item.FIELD_NAME === "Tax Area") {
                if (item.MASK_DEFAULT_VALUE != taxArea.MASK_ID) {
                    let taxArData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: taxArea.MASK_ID,
                    };
                    payLoadData.push(taxArData);
                }
            }
            else if (item.FIELD_NAME === "Cancelled Invoice Settings") {
                if (item.MASK_DEFAULT_VALUE != cncleInvSetting.MASK_ID) {
                    let cnclINVSettng = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: cncleInvSetting.MASK_ID,
                    };
                    payLoadData.push(cnclINVSettng);
                }
            }
            else if (item.FIELD_NAME === "Branch") {
                if (item.MASK_DEFAULT_VALUE != branch.MASK_ID) {
                    let branches = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: branch.MASK_ID,
                    };
                    payLoadData.push(branches);
                }
            }
            else if (item.FIELD_NAME === "Currency") {
                if (item.MASK_DEFAULT_VALUE != currency.MASK_ID) {
                    let currencyData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: currency.MASK_ID,
                    };
                
                    payLoadData.push(currencyData);
                }
            }
            else if (item.FIELD_NAME === "Division") {
                if (item.MASK_DEFAULT_VALUE != division.MASK_ID) {
                    let divisionData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: division.MASK_ID,
                    };
                    payLoadData.push(divisionData);
                }
            }
            else if (item.FIELD_NAME === "GRN Tolerance") {
                // Ensure tolerance is properly defined and update only when changed
                if (tolerance && item.MASK_DEFAULT_VALUE !== tolerance.MASK_ID) {
                    let toleranceData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: tolerance.MASK_ID ?? item.MASK_DEFAULT_VALUE, // Keep the modified value or default
                    };
                    payLoadData.push(toleranceData);
                    console.log("toleranceData",toleranceData);
                }
               
                
            }




            else if (item.FIELD_NAME === "Inspected By") {
                if (item.MASK_DEFAULT_VALUE != inspectedBy.MASK_ID) {
                    let inspectedByData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: inspectedBy.MASK_ID,
                    };
                    payLoadData.push(inspectedByData);
                }
            }
            else if (item.FIELD_NAME === "Location") {
                if (item.MASK_DEFAULT_VALUE != location.MASK_ID) {
                    let locationData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: location.MASK_ID,
                    };
                    payLoadData.push(locationData);
                }
            }
            else if (item.FIELD_NAME === "Mode Of Order") {
                if (item.MASK_DEFAULT_VALUE != modeofOrder.MASK_ID) {
                    let modeofOrderData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: modeofOrder.MASK_ID,
                    };
                    payLoadData.push(modeofOrderData);
                }
            }
            else if (item.FIELD_NAME === "Payment Term") {
                if (item.MASK_DEFAULT_VALUE != paymentTerm.MASK_ID) {
                    let paymentTermData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: paymentTerm.MASK_ID,
                    };
                    payLoadData.push(paymentTermData);
                }
            }
            else if (item.FIELD_NAME === "Raised By") {
                if (item.MASK_DEFAULT_VALUE != raisedBy.MASK_ID) {
                    let raisedByData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: raisedBy.MASK_ID,
                    };
                    payLoadData.push(raisedByData);
                }
            }
            else if (item.FIELD_NAME === "Receipt Mode") {
                if (item.MASK_DEFAULT_VALUE != receiptMode.MASK_ID) {
                    let receiptModeData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: receiptMode.MASK_ID,
                    };
                    payLoadData.push(receiptModeData);
                }
            }
            else if (item.FIELD_NAME === "Received By") {
                if (item.MASK_DEFAULT_VALUE != receivedBy.MASK_ID) {
                    let receivedByData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: receivedBy.MASK_ID,
                    };
                    payLoadData.push(receivedByData);
                }
            }
            else if (item.FIELD_NAME === "Sales Order Heading") {
                if (salesOrder && item.MASK_DEFAULT_VALUE != salesOrder.MASK_ID) {
                    let salesOrderData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: salesOrder.MASK_ID ?? item.MASK_DEFAULT_VALUE,
                    };
                    payLoadData.push(salesOrderData);
                }
            }
            else if (item.FIELD_NAME === "Stock Type") {
                if (item.MASK_DEFAULT_VALUE != stockType.MASK_ID) {
                    let stockTypeData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: stockType.MASK_ID,
                    };
                    payLoadData.push(stockTypeData);
                }
            }
            else if (item.FIELD_NAME === "Tax Form") {
                if (item.MASK_DEFAULT_VALUE != taxForm.MASK_ID) {
                    let taxFormData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: taxForm.MASK_ID,
                    };
                    payLoadData.push(taxFormData);
                }
            }
            else if (item.FIELD_NAME === "Tax Registration Code") {
                if (item.MASK_DEFAULT_VALUE != taxRegiCode.MASK_ID) {
                    let taxRegiCodeData = {
                        struser: auth.UserId,
                        strcompid: auth.CompId,
                        strdefid: item.MASK_DEF_ID,
                        strdefvalue: taxRegiCode.MASK_ID,
                    };
                    payLoadData.push(taxRegiCodeData);
                }
            }
            return null;
            // console.log(item.MASK_DEFAULT_VALUE);
            // console.log(item.MASK_DEF_ID);
            // console.log(item.FIELD_NAME);
        });
        if (payLoadData.length > 0) {
            let savePayload = {
                objDefaultSettings: payLoadData,
            };
            callingSaveApi(savePayload);
        } else {
            toast.warn("Change Default Settings to save data", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }
    };

    const callingSaveApi = (payload) => {
       
        // return;
        setLoading(true);
        createAPIDefaultEndpoint()
            .post(`${Endpoint.SaveDefaultSettings}`, JSON.stringify(payload), {
                headers: { "Content-Type": "application/json" },
            })
            .then((res) => {

                toast.success(`${res.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                setLoading(false);
                setDrpdwnVisblcnclInvSettng(true);
                setDrpdwnVisblWhrHus(true);
                setDrpdwnVisblTxAr(true);
                setDrpdwnVisblSupp(true);
                setDrpdwnVisblOrdrCncl(true);
                setDrpdwnVisblNonInv(true);
                setDrpdwnVisblApprovedBy(true);
                setDrpdwnVisblBranch(true);
                setDrpdwnVisblCurrency(true);
                setDrpdwnVisblDivision(true);
                setDrpdwnVisblInspectedBy(true);
                setDrpdwnVisblLocation(true);
                setDrpdwnVisblModeofOrder(true);
                setDrpdwnVisblPaymentTerm(true);
                setDrpdwnVisblRaisedBy(true);
                setDrpdwnVisblReceiptMode(true);
                setDrpdwnVisblReceivedBy(true);
                setDrpdwnVisblStockType(true);
                setDrpdwnVisblTaskForm(true);
                setDrpdwnVisblTaxRegiCode(true);
                fetchAllData();
            })
            .catch((error) => {
                console.log("error", error);
                setLoading(false);
            });
    };

    const fetchApiAllData = (
        maskDefId,
        maskValColmn,
        dispCol,
        tblName,
        hotSearch,
        defltValue
    ) => {
        createAPIDefaultEndpoint()
            .get(
                `${Endpoint.PopulateGridData}?CompId=${auth.CompId}&MASK_VALUE_COL=${maskValColmn}&MASK_DISPLAY_COL=${dispCol}&MASK_TABLE_NAME=${tblName}`
            )
            .then((val) => {
                let objValueData = { MASK_ID: defltValue, DEFAULT_VALUE: hotSearch };
                if (maskDefId == "34") {
                    setNonInvSuppOptions(val.data);
                    setNonInvSupp(objValueData);
                } else if (maskDefId == "35") {
                    setOrderCancellationReasonOptions(val.data);
                    setOrderCancellationReason(objValueData);
                } else if (maskDefId == "15") {
                    setSupplierOptions(val.data);
                    setSupplier(objValueData);
                } else if (maskDefId == "5") {
                    setTaxAreaOptions(val.data);
                    setTaxArea(objValueData);
                } else if (maskDefId == "3") {
                    setWarehouseOptions(val.data);
                    setWarehouse(objValueData);
                }
                else if (maskDefId == "36") {
                    setcncleInvSettingOptions(val.data);
                    setCncleInvSetting(objValueData);
                }
                else if (maskDefId == "11") {
                    setApprovedByOption(val.data);
                    setApprovedBy(objValueData);
                }
                else if (maskDefId == "31") {
                    setBranchOption(val.data);
                    setBranch(objValueData);
                }
                else if (maskDefId == "17") {
                    setCurrencyOption(val.data);
                    setCurrency(objValueData);
                }
                else if (maskDefId == "1") {
                    setDivisionOption(val.data);
                    setDivision(objValueData);
                }
                else if (maskDefId == "23") {
                    // setToleranceOption(val.data);
                    setTolerance(objValueData);
                }
                else if (maskDefId == "26") {
                    setLocationOption(val.data);
                    setLocation(objValueData);
                }
                else if (maskDefId == "9") {
                    setInspectedByOption(val.data);
                    setInspectedBy(objValueData);
                }

                else if (maskDefId == "7") {
                    setModeofOrderOption(val.data);
                    setModeofOrder(objValueData);
                }
                else if (maskDefId == "4") {
                    setPaymentTermOption(val.data);
                    setPaymentTerm(objValueData);
                }
                else if (maskDefId == "10") {
                    setRaisedByOption(val.data);
                    setRaisedBy(objValueData);
                }
                else if (maskDefId == "18") {
                    setReceiptModeOption(val.data);
                    setReceiptMode(objValueData);
                }
                else if (maskDefId == "8") {
                    setReceivedByOption(val.data);
                    setReceivedBy(objValueData);
                }
                else if (maskDefId == "16") {
                    setSalesOrder(objValueData);
                }
                else if (maskDefId == "12") {
                    setStockTypeOption(val.data);
                    setStockType(objValueData);
                }
                else if (maskDefId == "2") {
                    setTaxFormOption(val.data);
                    setTaxForm(objValueData);
                }
                else if (maskDefId == "19") {
                    setTaxRegiCodeOption(val.data);
                    setTaxRegiCode(objValueData);
                }

            })
            .catch((error) => {
                console.log(error);
            });
    };

    if (loading) {
        return (
            <>
                <Loader />
            </>
        );
    } else {
        return (
            <main>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Default Settings</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end mb-2">
                                <button type="submit"
                                    className="btn btn-primary"
                                    onClick={handelSaveData}
                                //   disabled={btnDisble}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                    <section className="sales-box">
                        <div className="row default-settings-panel">
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Non Inventory Supplier</label>
                                        <Dropdown
                                            value={nonInvSupp}
                                            onChange={(e) => {
                                                setNonInvSupp(e.value);
                                                // setDrpdwnVisblNonInv(true);
                                            }}
                                            filter
                                            options={nonInvSuppOptions}
                                            optionLabel="DEFAULT_VALUE"
                                            disabled={drpdwnVisblNonInv}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblNonInv(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">
                                            Order Cancellation Reason
                                        </label>
                                        <Dropdown
                                            value={orderCancellationReason}
                                            onChange={(e) => {
                                                setOrderCancellationReason(e.value);
                                                // setDrpdwnVisblOrdrCncl(true);
                                            }}
                                            filter
                                            options={orderCancellationReasonOptions}
                                            optionLabel="DEFAULT_VALUE"
                                            disabled={drpdwnVisblOrdrCncl}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblOrdrCncl(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Supplier</label>
                                        <Dropdown
                                            value={supplier}
                                            onChange={(e) => {
                                                setSupplier(e.value);
                                                // setDrpdwnVisblSupp(true);
                                            }}
                                            filter
                                            options={supplierOptions}
                                            optionLabel="DEFAULT_VALUE"
                                            disabled={drpdwnVisblSupp}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblSupp(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Tax Area</label>
                                        <Dropdown
                                            value={taxArea}
                                            onChange={(e) => {
                                                setTaxArea(e.value);
                                                // setDrpdwnVisblTxAr(true);
                                            }}
                                            filter
                                            options={taxAreaOptions}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblTxAr}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblTxAr(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Warehouse</label>
                                        <Dropdown
                                            value={warehouse}
                                            onChange={(e) => {
                                                setWarehouse(e.value);
                                            }}
                                            filter
                                            options={warehouseOptions}
                                            optionLabel="DEFAULT_VALUE"
                                            disabled={drpdwnVisblWhrHus}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblWhrHus(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Cancelled Invoice Settings</label>
                                        <Dropdown
                                            value={cncleInvSetting}
                                            onChange={(e) => {
                                                setCncleInvSetting(e.value);
                                                // setDrpdwnVisblcnclInvSettng(true);
                                            }}
                                            filter
                                            options={cncleInvSettingOptions}
                                            optionLabel="DEFAULT_VALUE"
                                            disabled={drpdwnVisblcnclInvSettng}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblcnclInvSettng(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Approved By</label>
                                        <Dropdown
                                            value={approvedBy}
                                            onChange={(e) => {
                                                setApprovedBy(e.value);
                                                // setDrpdwnVisblcnclInvSettng(true);
                                            }}
                                            filter
                                            options={approvedByOption}
                                            optionLabel="DEFAULT_VALUE"
                                            disabled={drpdwnVisblApprovedBy}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblApprovedBy(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Branch</label>
                                        <Dropdown
                                            value={branch}
                                            onChange={(e) => {
                                                setBranch(e.value);

                                            }}
                                            filter
                                            options={branchOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblBranch}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblBranch(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Currency</label>
                                        <Dropdown
                                            value={currency}
                                            onChange={(e) => {
                                                setCurrency(e.value);

                                            }}
                                            filter
                                            options={currencyOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblCurrency}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblCurrency(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Division</label>
                                        <Dropdown
                                            value={division}
                                            onChange={(e) => {
                                                setDivision(e.value);

                                            }}
                                            filter
                                            options={divisionOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblDivision}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblDivision(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">GRN Tolerance</label>
                                        <InputText
                                            className="form-control"
                                            value={tolerance?.MASK_ID || ""}
                                            onChange={(e) => setTolerance({ ...tolerance, MASK_ID: e.target.value })} // Update state on change
                                        />

                                    </div>
                                    <div className="col-2">

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Inspected By</label>
                                        <Dropdown
                                            value={inspectedBy}
                                            onChange={(e) => {
                                                setInspectedBy(e.value);

                                            }}
                                            filter
                                            options={inspectedByOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblInspectedBy}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblInspectedBy(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Location</label>
                                        <Dropdown
                                            value={location}
                                            onChange={(e) => {
                                                setLocation(e.value);

                                            }}
                                            filter
                                            options={locationOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblLocation}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblLocation(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Mode Of Order</label>
                                        <Dropdown
                                            value={modeofOrder}
                                            onChange={(e) => {
                                                setModeofOrder(e.value);

                                            }}
                                            filter
                                            options={modeofOrderOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblModeofOrder}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblModeofOrder(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Payment Term</label>
                                        <Dropdown
                                            value={paymentTerm}
                                            onChange={(e) => {
                                                setPaymentTerm(e.value);

                                            }}
                                            filter
                                            options={paymentTermOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblPaymentTerm}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblPaymentTerm(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Raised By</label>
                                        <Dropdown
                                            value={raisedBy}
                                            onChange={(e) => {
                                                setRaisedBy(e.value);

                                            }}
                                            filter
                                            options={raisedByOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblRaisedBy}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblRaisedBy(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Receipt Mode</label>
                                        <Dropdown
                                            value={receiptMode}
                                            onChange={(e) => {
                                                setReceiptMode(e.value);

                                            }}
                                            filter
                                            options={receiptModeOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblReceiptMode}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblReceiptMode(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Received By</label>
                                        <Dropdown
                                            value={receivedBy}
                                            onChange={(e) => {
                                                setReceivedBy(e.value);

                                            }}
                                            filter
                                            options={receivedByOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblReceivedBy}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblReceivedBy(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Sales Order Heading</label>
                                        <InputText className="form-control" value={salesOrder?.MASK_ID || ""}  onChange={(e) => setSalesOrder({ ...salesOrder, MASK_ID: e.target.value })} />

                                    </div>
                                    <div className="col-2">

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Stock Type</label>
                                        <Dropdown
                                            value={stockType}
                                            onChange={(e) => {
                                                setStockType(e.value);

                                            }}
                                            filter
                                            options={stockTypeOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblStockType}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblStockType(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Tax Form</label>
                                        <Dropdown
                                            value={taxForm}
                                            onChange={(e) => {
                                                setTaxForm(e.value);

                                            }}
                                            filter
                                            options={taxFormOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblTaxForm}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblTaskForm(false)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-10 pe-0">
                                        <label className="form-label">Tax Registration Code</label>
                                        <Dropdown
                                            value={taxRegiCode}
                                            onChange={(e) => {
                                                setTaxRegiCode(e.value);

                                            }}
                                            filter
                                            options={taxRegiCodeOption}
                                            optionLabel={"DEFAULT_VALUE"}
                                            disabled={drpdwnVisblTaxRegiCode}
                                        />
                                    </div>
                                    <div className="col-2">
                                        <img
                                            src={require("../../../Assets/Images/editIcon.png")}
                                            style={{ width: "26px" }}
                                            className="EditImageIcon"
                                            onClick={() => setDrpdwnVisblTaxRegiCode(false)}
                                        />
                                    </div>
                                </div>
                            </div>


                        </div>
                    </section>
                </div>
            </main>
        );
    }
};

export default DefaultSettings;
